<template>
	<div class="icg-calc">
		<div v-if="fieldData">
			<FieldGroup
				v-for="(fields, index) in fieldData"
				:legend="fields.label"
				:fields="fields.fields"
				:key="index"
			/>
			<GrandTotal />
		</div>
		<p v-else>{{ error }}</p>
		<BaseLoader v-if="loading" />
	</div>
</template>

<script>
import { store, mutations } from "./store";
import BaseLoader from "./components/BaseLoader.vue";
import FieldGroup from "./components/FieldGroup.vue";
import GrandTotal from "./components/GrandTotal.vue";

const axios = require("axios");

export default {
	components: {
		BaseLoader,
		FieldGroup,
		GrandTotal
	},

	data() {
		return {
			fieldData: null,
			error: null,
			loading: false,
			store: store
		};
	},

	methods: {
		fetchFieldData() {
			let self = this;
			this.loading = true;

			axios
				.get(
					location.protocol +
						"//" +
						location.host +
						// "https://www.icgnews.com" +
						"/wp-json/dazzle/v1/calculator/" +
						store.calculator
				)
				.then(function(response) {
					self.fieldData = response.data;
					self.loading = false;
				})
				.catch(function(error) {
					self.error = error;
					self.loading = false;
				});
		},

		fetchSetupOpts() {
			let self = this;
			this.loading = true;

			axios
				.get(
					location.protocol +
						"//" +
						location.host +
						// "https://www.icgnews.com" +
						"/wp-json/dazzle/v1/calculator/setup"
				)
				.then(function(response) {
					mutations.setSetupCosts(response.data);
				})
				.catch(function(error) {
					self.error = error;
					self.loading = false;
				});
		}
	},

	mounted() {
		let calculatorData = document.getElementById("icg-calculator-data");

		if (calculatorData) {
			mutations.setCalculator(calculatorData.getAttribute("data-type"));
			mutations.setProductId(calculatorData.getAttribute("data-pid"));
			this.fetchSetupOpts();
			this.fetchFieldData();
		} else {
			this.error = "Invalid calculator";
		}
	}
};
</script>
